var _excluded = ["avatar", "email", "firstName", "id", "lastName", "size", "alt"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.function.bind.js";
import React from 'react';
import ImageAvatar from "./ImageAvatar";
import InitialsAvatar from "./InitialsAvatar";
export var UserAvatarSize = /*#__PURE__*/function (UserAvatarSize) {
  UserAvatarSize["sm"] = "sm";
  UserAvatarSize["md"] = "md";
  UserAvatarSize["lg"] = "lg";
  return UserAvatarSize;
}({});
var getInitials = function getInitials(firstName, lastName) {
  var email = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  return firstName || lastName ? "".concat(firstName ? firstName.charAt(0) : '').concat(lastName ? lastName.charAt(0) : '') : email.slice(0, 2);
};
var Avatar = function Avatar(_ref) {
  var avatar = _ref.avatar,
    email = _ref.email,
    firstName = _ref.firstName,
    id = _ref.id,
    lastName = _ref.lastName,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? UserAvatarSize.md : _ref$size,
    alt = _ref.alt,
    props = _objectWithoutProperties(_ref, _excluded);
  return avatar ? /*#__PURE__*/React.createElement(ImageAvatar, _extends({
    uniqueID: id,
    avatar: avatar,
    size: size,
    alt: alt
  }, props)) : /*#__PURE__*/React.createElement(InitialsAvatar, _extends({
    uniqueID: id,
    size: size,
    text: getInitials(firstName, lastName, email)
  }, props));
};
export default Avatar;